import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms'; // For ngModel

@Component({
  selector: 'app-cookies-consent',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './cookies-consent.component.html',
  styleUrls: ['./cookies-consent.component.scss'],
})
export class CookiesConsentComponent implements OnInit {
  showBanner = false;
  customizeMode = false;
  consent = {
    functional: true,
    analytics: false,
    marketing: false,
  };

  ngOnInit(): void {
    const stored = localStorage.getItem('cookiesConsent');
    if (!stored) {
      this.showBanner = true;
    } else {
      this.consent = JSON.parse(stored);
    }
    if (this.consent.marketing) {
      this.loadClarity();
    }
  }

  loadClarity() {
    if ((window as any).clarityLoaded) return;

    const clarityBootstrap = document.createElement('script');
    clarityBootstrap.id = 'clarity-bootstrap';
    clarityBootstrap.type = 'text/javascript';
    clarityBootstrap.text = `
    (function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function() {
        (c[a].q = c[a].q || []).push(arguments);
      };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/syqx4f1lap";
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "syqx4f1lap");
  `;
    document.head.appendChild(clarityBootstrap);

    (window as any).clarityLoaded = true;
  }
  // loadClarity() {
  //   if (!document.getElementById('clarity-script')) {
  //     const script = document.createElement('script');
  //     script.id = 'clarity-script';  // Add an ID for future checks
  //     script.innerHTML = `
  //       (function(c,l,a,r,i,t,y){
  //         c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  //         t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/syqx4f1lap";
  //         y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  //       })(window, document, "clarity", "script", "syqx4f1lap");
  //     `;
  //     document.head.appendChild(script);
  //   }
  // }

  acceptAllCookies() {
    this.consent = { functional: true, analytics: true, marketing: true };
    this.saveConsent();
  }

  rejectAllCookies() {
    this.consent = { functional: true, analytics: false, marketing: false };
    this.saveConsent();
  }

  customizeCookies() {
    this.customizeMode = true;
  }
  backToMain() {
    this.customizeMode = false;
  }

  savePreferences() {
    this.saveConsent();
  }

  private saveConsent() {
    localStorage.setItem('cookiesConsent', JSON.stringify(this.consent));
    this.showBanner = false;
    if (this.consent.marketing) {
      this.loadClarity();
    }
  }
}
